import React from 'react';
import { useGoalTrackQuery } from './api/useGoalTrackQuery';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Chart } from './components/Chart/Chart';
import { ErrorState } from '../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { FullPageLoading } from '../CommonComponents/OPL/FullpageLoading/FullPageLoading';
import { Table } from './components/Table/Table';
import { Text } from '../CommonComponents/OPL/Text/Text';

export const GoalTrack = () => {
  const { data, isLoading, error, refetch } = useGoalTrackQuery();

  if (isLoading) {
    return (
      <FullPageLoading />
    );
  }

  if (error) {
    return (
      <Box display="flex" flex={1}>
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <>
      <Text as="h1" mb="32" fontWeight={600} fontSize="h6" width="100%" p="16">
        Goal Track
      </Text>

      <Chart data={data} />

      <Table data={data} />
    </>
  );
};
